var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-item',{attrs:{"label":_vm.label}},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"wrap-label"},[_vm._v(_vm._s(_vm.mValue?_vm.mOptions.trueLabel:_vm.mOptions.falseLabel))]),_c('el-checkbox',{model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }